module.exports = __webpack_public_path__ + "static/team-2-52787c9bc5a66ace9d02f4a40479705b.jpg";